namespace Portico.Models.Enterprise {
    import pmg = Portico.Models.Gateway;

    export interface IIntakeLayout {
        id: number;
        programId: number;
        intakeType: string;
        intakeLayoutCode: string;
        intakeLayoutDescription: string;
        docTypeId: number;
        generatedCaseTypeId: number;
        intakeLayoutSequence: number;
        layoutSections: LayoutSection[];
        surveyIds: number[];
        surveys: Survey[];

		getLayoutSection(name: string, current?: string): LayoutSection;
		getLayoutSectionIndex(name: string, current?: string): number;
		getSurveyByQuestionId(questionId: number): Survey;
		getSurveyAnswer(questionId: number, answerId: number): SurveyAnswer;
		getSurveyQuestion(questionId: number): SurveyQuestion;
		hasLayoutSection(name: string, current?: string): boolean;
    }

    export class IntakeLayout implements IIntakeLayout {
        id: number;
        programId: number;
        intakeType: string;
        intakeLayoutCode: string;
        intakeLayoutDescription: string;
        docTypeId: number;
        generatedCaseTypeId: number;
        intakeLayoutSequence: number;
        layoutSections: LayoutSection[];
        surveyIds: number[];
        surveys: Survey[];

        constructor(obj?: IIntakeLayout | any) {
            this.id = null;
            this.programId = null;
            this.intakeType = null;
            this.intakeLayoutCode = null;
            this.intakeLayoutDescription = null;
            this.docTypeId = null;
            this.generatedCaseTypeId = null;
            this.intakeLayoutSequence = null;
            this.layoutSections = null;
            this.surveyIds = null;
            this.surveys = null;

            if (obj) {
                this.id = obj.id;
                this.programId = obj.programId;
                this.intakeType = obj.intakeType;
                this.intakeLayoutCode = obj.intakeLayoutCode;
                this.intakeLayoutDescription = obj.intakeLayoutDescription;
                this.docTypeId = obj.docTypeId;
                this.generatedCaseTypeId = obj.generatedCaseTypeId;
                this.intakeLayoutSequence = obj.intakeLayoutSequence;
                this.layoutSections = [];
                this.surveyIds = [];
                this.surveys = [];

                if (obj.layoutSections) {
                    for (const layoutSection of obj.layoutSections) {
                        this.layoutSections.push(new LayoutSection(layoutSection));
                    }
                }

                if (obj.surveyIds) {
                    for (const surveyId of obj.surveyIds) {
                        this.surveyIds.push(surveyId);
                    }
                }

                if (obj.surveys) {
                    for (const survey of obj.surveys) {
                        this.surveys.push(new Survey(survey));
                    }
                }
            }
        }

		getLayoutSection(name: string, current: string = null): LayoutSection {
			const index = this.getLayoutSectionIndex(name, current);
			return index > -1 ? this.layoutSections[index] : null;
		}

		getLayoutSectionIndex(name: string, current: string = null): number {
			if (name === 'first') {
				return 0;
			} else if (name === 'previous') {
				return this.getLayoutSectionIndex(current) - 1;
			} else if (name === 'next') {
				return this.getLayoutSectionIndex(current) + 1;
			} else if (name === 'last') {
				return this.layoutSections.length - 1;
			}

			for (let i = 0; i < this.layoutSections.length; i++) {
				const layoutSection = this.layoutSections[i];

				if (layoutSection.name === name) {
					return i;
				}
			}

			return -1;
		}

		getSurveyByQuestionId(questionId: number): Survey {
			for (let i = 0; i < this.surveys.length; i++) {
				const survey = this.surveys[i];
				const surveyQuestion = survey.getSurveyQuestion(questionId);

				if (surveyQuestion) {
					return survey;
				}
			}

			return null;
		}

		getSurveyAnswer(questionId: number, answerId: number): SurveyAnswer {
			const surveyQuestion = this.getSurveyQuestion(questionId);
			const surveyAnswer = surveyQuestion.getSurveyAnswer(answerId);

			return surveyAnswer;
		}

		getSurveyQuestion(questionId: number): SurveyQuestion {
			for (let i = 0; i < this.surveys.length; i++) {
				const survey = this.surveys[i];
				const surveyQuestion = survey.getSurveyQuestion(questionId);

				if (surveyQuestion) {
					return surveyQuestion;
				}
			}

			return null;
		}

		hasLayoutSection(name: string, current: string = null): boolean {
			const index = this.getLayoutSectionIndex(name, current);
			return index >= 0 && index < this.layoutSections.length;
		}
    }
}